import getTemplate from 'src/tpl';
import INBOX from 'INBOX';

const
    buttonTemplate = getTemplate('template-dialog-button'),
    dialogTemplate = getTemplate('template-dialog');

INBOX.namespace('classes.Dialog', function () {
    return function (title, body, buttons, onClick, id) {
        this.title = title;
        this.body = body;
        this.buttons = buttons;
        this.onClick = onClick;
        this.id = id || null;

        this.render = function () {

            var that = this, buttons = '';

            $.each(this.buttons, function (i, button) {
                if (typeof button == 'string') {
                    button = { title: button };
                }
                buttons += buttonTemplate({
                    title: button.title,
                    type: button.type || 'secondary'
                });
            });

            this.el = $(dialogTemplate({
                title: this.title,
                body: typeof this.body == 'string' ? this.body : '',
                buttons: buttons,
                did: this.id
            }, true));

            if (typeof this.body == 'object') {
                this.el.prepend(this.body);
            }

            $('.ui-dialog-buttonpane', this.el).on('click', 'button', function (e) {
                if (that.onClick) {
                    that.onClick(that, $(e.target).index());
                }
                that.hide();
            });

            return this;
        };

        this.show = function () {
            this.el.dialog({
                dialogClass: 'ii-dialog',
                height: 'auto',
                // minWidth: 250,
                modal: true,
                position: {
                    my: 'bottom',
                    at: 'center',
                    of: window
                },
                resizable: false,
                width: 'auto',
                // Sets the real CSS property 'min-width'.
                // NOTE: This method might be overwritten by other scripts
                create: function () {
                    $(this).css('min-width', '250px');
                }
            });
        };

        this.hide = function () {
            this.el.dialog('close');
        };

        this.destroy = function () {
            this.el.dialog('destroy');
        };
    };
});
